/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flyerbackgroundcustom2Inputs */

const en_flyerbackgroundcustom2 = /** @type {(inputs: Flyerbackgroundcustom2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom background color`)
};

const de_flyerbackgroundcustom2 = /** @type {(inputs: Flyerbackgroundcustom2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eigene Hintergrundfarbe`)
};

/**
* | output |
* | --- |
* | "Custom background color" |
*
* @param {Flyerbackgroundcustom2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const flyerbackgroundcustom2 = /** @type {((inputs?: Flyerbackgroundcustom2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flyerbackgroundcustom2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_flyerbackgroundcustom2(inputs)
	return de_flyerbackgroundcustom2(inputs)
});
export { flyerbackgroundcustom2 as "flyerBackgroundCustom" }